// Month-grid date math (LAYOUT-ARCHITECTURE.md §4.3). Pure + unit-tested so the
// grid stays a dumb renderer. Week starts Sunday (matches useCalendarNavigation).

import {
  addDays,
  isSameMonth as dfIsSameMonth,
  startOfMonth,
  startOfWeek,
} from 'date-fns'

// Sunday-start week — not locale-derived.
const WEEK_STARTS_ON = 0

// 6 weeks × 7 days — a fixed grid so every month lays out identically.
export const MONTH_MATRIX_DAYS = 42

/**
 * The 42 days of the month grid for `cursor`, starting on the Sunday of the week
 * containing the 1st. Six full weeks, so any month (incl. a 6-row February that
 * starts on a Saturday) fits without the row count shifting.
 */
export function monthMatrix(cursor: Date): Date[] {
  const gridStart = startOfWeek(startOfMonth(cursor), {
    weekStartsOn: WEEK_STARTS_ON,
  })
  return Array.from({ length: MONTH_MATRIX_DAYS }, (_, i) =>
    addDays(gridStart, i),
  )
}

/** True when `day` falls in the same calendar month as `cursor` (in-month cell). */
export function isSameMonth(day: Date, cursor: Date): boolean {
  return dfIsSameMonth(day, cursor)
}
